import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, db } from '../services/firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import InterestsSettings from '../components/InterestsSettings';
import { toast, ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

function ProfileAfterLoginPage() {
  const [userData, setUserData] = useState({
    email: '',
    uid: '',
    yearOfBirth: '',
    displayName: '',
    gender: '',
    interests: [],
  });

  const [newInterest, setNewInterest] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userDoc = await getDoc(doc(db, 'users', user.uid));
        const data = userDoc.exists() ? userDoc.data() : {};
        setUserData({
          email: user.email,
          uid: user.uid,
          yearOfBirth: data.yearOfBirth || '',
          displayName: data.displayName || '',
          gender: data.gender || '',
          interests: data.interests || [],
        });
      } else {
        navigate('/auth/login');
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const validateUserData = () => {
    const missingFields = [];

    if (!userData.yearOfBirth) missingFields.push('Year of birth');
    if (!userData.displayName) missingFields.push('Displayed name');
    if (!userData.gender) missingFields.push('Gender');
    if (!userData.interests || userData.interests.length === 0) missingFields.push('At least one interest');

    if (missingFields.length > 0) {
      toast.error(`Please fill in the required fields: ${missingFields.join(', ')}`);
      return false;
    }

    return true;
  };

  const handleSave = async () => {
    if (!validateUserData()) return;

    setIsSaving(true);
    try {
      await setDoc(doc(db, 'users', userData.uid), {
        ...userData,
      }, { merge: true });

      // Save only displayName to 'user_public' collection
      await setDoc(doc(db, 'users_public', userData.uid), {
        displayName: userData.displayName,
      }, { merge: true });

      navigate('/home');
    } catch (error) {
      console.error('Save error:', error);
      toast.error('Failed to save profile. Please try again.');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="container py-5">
      <h3 className="mb-4 text-center">
        Tell us about yourself so we can find better matches for you
      </h3>

      <InterestsSettings
        userData={userData}
        setUserData={setUserData}
        newInterest={newInterest}
        setNewInterest={setNewInterest}
      />

      <div className="text-center mt-4">
        <button className="btn btn-primary" onClick={handleSave} disabled={isSaving}>
          {isSaving ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Saving...
            </>
          ) : (
            'Save and Continue'
          )}
        </button>
      </div>

      <ToastContainer position="top-center" autoClose={3000} />
    </div>
  );
}

export default ProfileAfterLoginPage;
